/*
 * SDG selector component
 */
import React from 'react';
import {
  Mode,
  castDataType,
  DataType
} from '../common.jsx';
import Setting from './setting.jsx';

import Selection from './selection.jsx';

export default class AdaliaMESdgSelector extends Selection {

        static get TYPE() {
            return 'adalia_me_sdg_selector';
        }

        static icon(){
            return <i className="fa fa-picture-o"></i>;
        }

        static defaultContent(language) {
            let content = Object.assign(super.defaultContent(language), {
                maxGoals: 0
            });
            content.options[0].options = [];
            content.translations[language] = content.translations[language] || {};
            content.translations[language].label = I18n.t('sustainable_development_goals', {scope: 'fe', locale: language});
            content.translations.en = content.translations.en || {};
            [
                "1: End poverty in all its forms everywhere",
                "2: End hunger, achieve food security and improved nutrition and promote sustainable agriculture",
                "3: Ensure healthy lives and promote well-being for all at all ages",
                "4: Ensure inclusive and quality education for all and promote lifelong learning",
                "5: Achieve gender equality and empower all women and girls",
                "6: Ensure access to water and sanitation for all",
                "7: Ensure access to affordable, reliable, sustainable and modern energy for all",
                "8: Promote inclusive and sustainable economic growth, employment and decent work for all",
                "9: Build resilient infrastructure, promote sustainable industrialization and foster innovation",
                "10: Reduce inequality within and among countries",
                "11: Make cities inclusive, safe, resilient and sustainable",
                "12: Ensure sustainable consumption and production patterns",
                "13: Take urgent action to combat climate change and its impacts",
                "14: Conserve and sustainably use the oceans, seas and marine resources",
                "15: Sustainably manage forests, combat desertification, halt and reverse land degradation, halt biodiversity loss",
                "16: Promote just, peaceful and inclusive societies",
                "17: Revitalize the global partnership for sustainable development"
            ].forEach((translation, i) => {
                let key = this.generateOptionTranslationKey();
                content.options[0].options.push({value: '' + (i + 1), label: key});
                content.translations.en[key] = translation;
            });
            return content;
        }

        renderView() {
            let maxGoals = (parseInt(this.props.content.maxGoals) > 0 ? ' (' + I18n.t('validation_max', {scope: 'fe', locale: this.props.language}) + ' ' + String(this.props.content.maxGoals) + ')' : '')
            return (
                <div style={{ width: '100%', display: 'inline-block'}}>
                    <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                        <span className="field-label">{this.getText('label')}</span>
                        {maxGoals}
                        {this.props.content.required ? <span className='required-field'> *</span> : null}
                        {this.helpIcon()}
                        {this.renderPrefillIcon()}
                    </label>
                    {this.descriptionText()}
                    {this.renderOptions()}
                </div>
            );
        }

        renderSettings() {
            let lockEditWhenPrefilled = this.props.content.lockEditWhenPrefilled ? true : false;
            let containsSensitiveInformation = this.props.content.containsSensitiveInformation ? true : false;

            return (
                <div>
                    <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
                    <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                    <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
                    <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                    <Setting.TextField name="maxGoals" label={I18n.t('field_max_goals', {scope: 'fe'})} value={this.props.content.maxGoals} onChange={this.updateSettings} description={I18n.t('field_max_goals_description', {scope: 'fe'})} />
                    <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
                    <Setting.TextField
                      name="reportKey"
                      label={I18n.t('field_report_key', {scope: 'fe'})}
                      value={this.props.content.reportKey}
                      description={I18n.t('field_report_key_description', {scope: 'fe'})}
                      {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
                    />
                    <Setting.Checkbox name="lockEdit" label={I18n.t('field_lock_edit', {scope: 'fe'})} description={I18n.t('field_lock_edit_description', {scope: 'fe'})} value={this.props.content.lockEdit} onChange={this.updateSettings} />
                    {AppConfig.features.form_prefill ? <Setting.Checkbox name="lockEditWhenPrefilled" label={I18n.t('field_lock_edit_when_prefilled', {scope: 'fe'})} description={I18n.t('field_lock_edit_when_prefilled_description', {scope: 'fe'})} value={this.props.content.lockEditWhenPrefilled} onChange={this.updateSettings} /> : null}
                    <Setting.Checkbox
                      name="containsSensitiveInformation"
                      label={I18n.t('field_contains_sensitive_information', {scope: 'fe'})}
                      description={I18n.t('field_contains_sensitive_information_description', {scope: 'fe'})}
                      value={this.props.content.containsSensitiveInformation}
                      {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
                    />
                </div>
            );
        }

        componentDidMount() {
            super.componentDidMount();

            if (this.props.mode == Mode.FILL && !this.isReadOnlyAnswer()) {
                jQuery(this.refs.root).find('.sdg').on('click', (event) => {
                    let sdg = jQuery(event.currentTarget);
                    let maxGoals = parseInt(sdg.attr('data-max-goals'));
                    let checked = 0;
                    checked = sdg.closest('.adalia_me_sdg_selector').find('input:checked').length;

                    if (sdg.hasClass('selected')) {
                        sdg.removeClass();
                        sdg.addClass('sdg medium-small sdg-inverted-' + sdg.attr('id'));
                        sdg.closest('.adalia_me_sdg_selector').find('[data-sdg="' + sdg.attr('id') + '"]').prop('checked', false);
                    } else {
                        if (checked >= maxGoals && maxGoals > 0) {
                            alert(I18n.t('field_max_goals_description', {scope: 'fe', locale: this.props.language}) + "!");
                        } else {
                            sdg.removeClass();
                            sdg.addClass('sdg medium-small selected sdg-' + sdg.attr('id'));
                            sdg.closest('.adalia_me_sdg_selector').find('[data-sdg="' + sdg.attr('id') + '"]').prop('checked', true);
                        }
                    }
                    this.updateAnswer();
                });
            }
            if ([Mode.FILL, Mode.EDIT, Mode.VIEW].indexOf(this.props.mode) != -1) {
                jQuery(this.refs.root).find('[data-toggle="tooltip"]').tooltip();
            }
        }

        renderOptions() {
            let options = this.getOptions('_default').map((o, i) => {
                if (this.props.mode == Mode.VIEW) {
                    if (this.isChecked(String(o.value)) != -1) {
                        if (this.props.pdf) {
                            return (
                                <label key={o.value}>
                                    {I18n.t('sdg', {locale: this.props.language}) + ' ' + String(o.value) + ': ' + this.getText(o.label, o.label)}
                                </label>
                            );
                        } else {
                            return (
                                <label key={o.value}>
                                        <div id={o.value}
                                        name={this.fullFieldName(true)}
                                        className={"sdg medium-small sdg-" + String(o.value)}
                                        title={this.getText(o.label, o.label)}
                                        data-toggle = 'tooltip'/>
                                </label>
                            );
                        }
                    }
                } else {
                    let className = (this.isChecked(String(o.value)) != -1 ? "sdg medium-small selected sdg-" + String(o.value) : "sdg medium-small sdg-inverted-" + String(o.value))
                    return (
                        <div key={o.value}>
                            <input type="checkbox"
                                data-sdg={o.value}
                                name={this.fullFieldName(true)}
                                defaultValue={o.value}
                                checked={this.isChecked(String(o.value)) != -1}
                                readOnly
                                disabled={this.props.mode != Mode.FILL}
                                style={{display: 'none'}} />

                            <div id={o.value}
                                className={className}
                                title={this.getText(o.label)}
                                data-toggle = 'tooltip'
                                data-max-goals={this.props.content.maxGoals}>
                             </div>
                        </div>
                    );
                }
            });

            let className = (this.props.mode == Mode.FILL ? "sdgs fill" : "sdgs")
            let noSdgs = (this.props.mode == Mode.VIEW ? I18n.t('no_sdgs_selected', {locale: this.props.language}) : '')

            return (
                <div className={className}>
                    {options}
                    {((this.getAnswer() || []).length > 0) ? '' : noSdgs}
                </div>
            );
        }

        isChecked(id) {
            return (this.getAnswer() || []).indexOf(id);
        }

        beforeUpdateSettings(content) {
            content.required = castDataType(content.required, DataType.BOOLEAN);
            content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
            content.lockEditWhenPrefilled = castDataType(content.lockEditWhenPrefilled, DataType.BOOLEAN);
            content.lockEdit = castDataType(content.lockEdit, DataType.BOOLEAN);
        }

        getAnswer() {
            let answer = this.getRawAnswer();

            return (Array.isArray(answer) ? answer : [answer]).map((a) => {
                return castDataType(a, this.props.content.dataType || DataType.STRING);
            });
        }

        rawAnswerDefault() {
            return [];
        }
}
